import { render } from "./YearbookCard.vue?vue&type=template&id=55d4729a&scoped=true"
import script from "./YearbookCard.vue?vue&type=script&lang=js"
export * from "./YearbookCard.vue?vue&type=script&lang=js"

import "./YearbookCard.vue?vue&type=style&index=0&id=55d4729a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d4729a"]])

export default __exports__